import React, { useEffect, useRef, useState } from 'react';

// Debounced keyword input. Reports the final value upward after `delay` ms.
export default function SearchInput({ value, onChange, delay = 300 }) {
  const [local, setLocal] = useState(value || '');
  const timer = useRef(null);

  useEffect(() => {
    // Keep local synced when parent resets
    setLocal(value || '');
  }, [value]);

  const handleChange = (e) => {
    const v = e.target.value;
    setLocal(v);
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => onChange(v), delay);
  };

  const flushNow = () => {
    if (timer.current) clearTimeout(timer.current);
    onChange(local);
  };

  return (
    <div className="row">
      <input
        className="search-input"
        type="search"
        placeholder="Search accounts, contacts, opportunities…"
        value={local}
        onChange={handleChange}
        onKeyDown={(e) => e.key === 'Enter' && flushNow()}
        autoFocus
      />
      <button className="btn" onClick={flushNow} disabled={!local.trim()}>
        Search
      </button>
    </div>
  );
}
